module.exports = __webpack_public_path__ + "static/img/26.e0a04f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/26.jpg
// module id = w7f4
// module chunks = 1